<div class="container my-4" *transloco="let t; scope: 'ideas'">
  <div class="row">
    <div class="col-lg-8">
      <p class="lead">{{ t('ideas.submit_intro') }}</p>

      @if (restarted()) {
        <div class="alert alert-info">{{ t('ideas.started_again') }}</div>
      }
      @if (failure(); as failed) {
        <div class="alert alert-danger" role="alert">
          {{ t(failed.translationKey) }}
          @if (failed.detail) {
            <div class="small mt-1">{{ failed.detail }}</div>
          }
        </div>
      }

      @if (canCreate() && !maySubmitAtAll()) {
        <div class="alert alert-warning">{{ t('ideas.cannot_submit') }}</div>
      } @else {
        <form [formGroup]="form" (ngSubmit)="submit()">
          <div class="mb-3">
            <label class="form-label fw-bold" for="idea-name">{{ t('common.name') }}</label>
            <input id="idea-name" class="form-control" formControlName="name" [attr.maxlength]="nameMax" [class.is-invalid]="isInvalid('name')">
            <div class="form-text">{{ t('ideas.name_help') }}</div>
          </div>
          <div class="mb-3">
            <label class="form-label fw-bold" for="idea-words">{{ t('ideas.words_label') }}</label>
            <textarea id="idea-words" class="form-control" rows="8" formControlName="originalRequest" [attr.maxlength]="wordsMax" [class.is-invalid]="isInvalid('originalRequest')"></textarea>
            <div class="form-text">{{ t('ideas.words_help') }} {{ form.controls.originalRequest.value.length }} / {{ wordsMax }}</div>
          </div>

          @if (!hub && (mayCreatePublic() || targets().length)) {
            <fieldset class="mb-3">
              <legend class="form-label fw-bold fs-6">{{ t('ideas.who_sees_it') }}</legend>
              @if (mayCreatePublic()) {
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="idea-target-public" value="" formControlName="target">
                  <label class="form-check-label" for="idea-target-public">{{ t('ideas.target_public') }}</label>
                </div>
              }
              @for (option of targets(); track option.slug) {
                <div class="form-check">
                  <input class="form-check-input" type="radio" [id]="'idea-target-' + option.slug" [value]="option.slug" formControlName="target">
                  <label class="form-check-label" [for]="'idea-target-' + option.slug">{{ t('ideas.target_hub', { hub: option.name }) }}</label>
                </div>
              }
            </fieldset>
          } @else if (hub) {
            <p class="small"><i class="fa-regular fa-lock me-1"></i>{{ t('ideas.hub_submission_is_private') }}</p>
          }

          <p class="small text-muted">{{ t('ideas.approval_explanation') }}</p>
          <button type="submit" class="btn btn-primary" [disabled]="submitting() || form.invalid">{{ t('common.submit') }}</button>
        </form>
      }
    </div>
  </div>
</div>
